export default {
  /** 任务消息已读 */
  setTaskHasBeenRead: '/api/tasks/read',
  /** 查询未读消息数量 */
  getCountOfUnread: '/api/tasks/unread-count',
  /**更新订单*/
  orderUpdate: '/api/tasks/order-update',
  /**批量恢复订单 */
  batchRecoverUrl: '/api/sales/outbounds/batch-recover',
  /**批量导入 */
  batchImport: '/api/tasks/import',
}
